import { HEX_3D526B, HEX_F2F6FA } from '@tanium/colors';
import { defineColor, Text1 } from '@tanium/react-theme-definition';

export const AxisLabelText = Text1;
export const GridStroke = defineColor([HEX_F2F6FA, HEX_3D526B]);
